import {IOrderStatusModel} from '../../../../src/@interfaces/models/Order/IOrderStatusModel';
import {IOrderProductModel} from '../../../../src/@interfaces/models/Order/IOrderProductModel';
import {IUserContext} from '../../../../src/@interfaces/contexts/IUserContext';

export function isAttentionRequired(
    status?: Partial<IOrderStatusModel>,
    product?: Partial<IOrderProductModel>,
    user?: IUserContext['model'],
    can?: IUserContext['can'],
): boolean {
    const approvalRequired = (
        status?.id === product?.status_id &&
        product?.status_approval_state === 'required'
    );
    const isProductionMan = (can != null && can('users@is-production'));
    const canManageApproval = (
        can != null &&
        can('orders@can-judge-order-product-status-changing-approval')
    );
    const isDeadlineExpired = (
        product?.reason_of_deadline_expiration_is_required === true
    );

    return approvalRequired && canManageApproval && !isProductionMan || isDeadlineExpired;
}
